import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import SelectBox from "../../Fields/SelectBox";
import Typography from '@material-ui/core/Typography';
import TextInput from "../../Fields/TextInput";
import CheckBox from "../../Fields/CheckBox";
import RadioButton from '../../Fields/RadioButton';
import { RadioGroup, FormControlLabel } from '@material-ui/core';
import styles from "./SearchComponents.module.css"
import Tooltip from "@material-ui/core/Tooltip";
import { handleDecimalInput } from "../../../helpers/inputValidation";
import { calculateMaxMismatches, shouldDisplayMismatchText as checkMismatchDisplay } from "../../../helpers/mismatchCalculator";
import { getDocsUrl } from '../../../helpers/docsUrl';

const SearchAlgosSettings = (props) =>{

    const { formJson, setFormJson } = props

    const { t, i18n } = useTranslation('common');

    const [prevFrameSel, setPrevFrameSel] = useState("both");

    // Wrapper functions using shared mismatch calculator
    const getMaxMismatches = () => calculateMaxMismatches(
        formJson.searchInfo?.qdb_seq,
        formJson.searchInfo?.strat_genepast_perc_id
    );

    const shouldShowMismatch = () => checkMismatchDisplay(
        formJson.searchInfo?.qdb_seq,
        formJson.layout?.queryCount || 0,
        formJson.searchInfo?.strat_name,
        formJson.searchInfo?.strat_genepast_perc_id_over,
        formJson.searchInfo?.strat_genepast_perc_id
    );

    useEffect(()=>{

        let change = false;

        if(formJson.searchInfo){
            if(formJson.searchInfo.strat_name == undefined){
                formJson.searchInfo.strat_name = searchAlgorithmItems[0].value;
                change = true;
            }

            if(formJson.searchInfo.best_hit_keep_max == undefined){
                formJson.searchInfo.best_hit_keep_max = 5000;
                change = true;
            }

            if(formJson.searchInfo.strat_genepast_perc_id == undefined){
                formJson.searchInfo.strat_genepast_perc_id = "80";
                change = true;
            }

            if(formJson.searchInfo.frame_sel == undefined){
                formJson.searchInfo.frame_sel = "both";
                change = true;
            }

            if(formJson.searchInfo.strat_genepast_perc_id_over == undefined){
                formJson.searchInfo.strat_genepast_perc_id_over = genePastItems[0].value;
                change = true;
            }

            if(formJson.searchInfo.strat_blast_word_size_nuc == undefined){
                formJson.searchInfo.strat_blast_word_size_nuc = nucleotidewordSizeItems[1].value;
                change = true;
            }

            if(formJson.searchInfo.strat_blast_word_size_pro == undefined){
                formJson.searchInfo.strat_blast_word_size_pro = proteinwordSizeItems[1].value;
                change = true;
            }

            if(formJson.searchInfo.strat_blast_scoring_matrix_nuc == undefined){
                formJson.searchInfo.strat_blast_scoring_matrix_nuc = nucleotideMatrixItems[0].value;
                change = true;
            }

            if(formJson.searchInfo.strat_blast_scoring_matrix_pro == undefined){
                formJson.searchInfo.strat_blast_scoring_matrix_pro = proteinMatrixItems[0].value;
                change = true;
            }

            if(formJson.searchInfo.strat_blast_eval_cutoff == undefined){
                formJson.searchInfo.strat_blast_eval_cutoff = 10;
                change = true;
            }

            if(formJson.searchInfo.frame_sel == undefined){
                formJson.searchInfo.frame_sel = "both";
                change = true;
            }
        

            if(formJson.searchInfo.strat_blast_hsp == undefined){
                formJson.searchInfo.strat_blast_hsp = true;
                change = true;
            }

            if(formJson.searchInfo.strat_fragment_window_length_nuc == undefined){
                formJson.searchInfo.strat_fragment_window_length_nuc = 50;
                change = true;
            }

            if(formJson.searchInfo.strat_fragment_perc_id_nuc == undefined){
                formJson.searchInfo.strat_fragment_perc_id_nuc = 96;
                change = true;
            }

            if(formJson.searchInfo.strat_fragment_window_length_pro == undefined){
                formJson.searchInfo.strat_fragment_window_length_pro = 50;
                change = true;
            }

            if(formJson.searchInfo.strat_fragment_perc_id_pro == undefined){
                formJson.searchInfo.strat_fragment_perc_id_pro = 96;
                change = true;
            }

            if(formJson.searchInfo.match_tu == undefined){
                formJson.searchInfo.match_tu = "1";
                change = true;
            }

            if(change){
                setFormJson({...formJson});
            }
        }

    }, [formJson]);

   
    const searchAlgorithmItems = [
        {
            value: "kerr",
            label: "GenePast Search"
        },
        {
            value: "hash",
            label: "Gapless Search"
        },
        {
            value: "blast",
            label: "BLAST Search"
        },
        {
            value: "fragment",
            label: "Fragment Search"
        },
        {
            value: "motif",
            label: "MOTIF Search"
        }
    ];

    const genePastItems = [
        {
            value: "QUERY",
            label: "Query Sequence"
        },
        {
            value: "SUBJECT",
            label: "Subject Sequence"
        },
        {
            value: "SHORTER",
            label: "Query or Subject Sequence"
        }
    ];

    const nucleotideMatrixItems = [
        {
            value: "NUC.3.1",
            label: "NUC.3.1"
        },
        {
            value: "NUC.2.1",
            label: "NUC.2.1"
        },
        {
            value: "NUC.4.4",
            label: "NUC.4.4"
        }
    ];

    const nucleotidewordSizeItems = [
        {
            value: "7",
            label: "7"
        },
        {
            value: "11",
            label: "11"
        },
        {
            value: "15",
            label: "15"
        }
    ];

    const proteinMatrixItems = [
        {
            value: "BLOSUM62",
            label: "BLOSUM62"
        },
        {
            value: "PAM30",
            label: "PAM30"
        },
        {
            value: "PAM70",
            label: "PAM70"
        },
        {
            value: "BLOSUM80",
            label: "BLOSUM80"
        },
        {
            value: "BLOSUM45",
            label: "BLOSUM45"
        }
    ];

    const proteinwordSizeItems = [
        {
            value: "2",
            label: "2"
        },
        {
            value: "3",
            label: "3"
        }
    ];

    return(
        <div>
            <div style={{display: "flex", layout: "row", width: "100%"}}>
                <p className="subHeading w-50 mb-10">{t('searchAlgorithmAndSetting')}</p>
                <div style={{display:"flex", width: "100%", justifyContent: "right"}}>
                    <a 
                        className={"appLink"} 
                        href={getDocsUrl('sequence_comparison_algorithms.html', 'searchstrategy')}
                        target="_blank" rel="noreferrer" >{t('help')}
                    </a>
                </div>
            </div>
            <div style={{height: "auto", display: "flex"}}>
                <div style={{width: "210px", padding: "0 5px"}}>
                    {formJson.searchInfo.strat_name !== undefined &&
                        <SelectBox
                            margin="normal"
                            variant="outlined"
                            id="searchType"
                            value={formJson.searchInfo.strat_name}
                            items = {searchAlgorithmItems}
                            onChange={(e)=>{
                                let test = e.target.value;
                                formJson.searchInfo.strat_name = test;
                                 
                                if((test === "kerr" || test === "hash") && formJson.searchInfo.match_tu !== "1"){
                                    formJson.searchInfo.frame_sel = "for";
                                }

                                setFormJson({...formJson})
                            }}
                            className={""}
                        />
                    }
                </div>
                {formJson.searchInfo.strat_name !== null &&
                <div className={styles.alignMidRow}>
                    {formJson.searchInfo.strat_name === "motif" &&
                    <div className={styles.alignMidRow}>
                        <a style={{padding: "12px 15px", marginBottom: "12px"}} className={""} href={getDocsUrl('sequence_comparison_algorithms.html', 'searchstrategy')}>
                        {t("examplesOfValidMotif")}
                        </a>
                    </div>
                    }
                    {formJson.searchInfo.strat_name === "fragment" &&
                        <div style={{marginTop: "-13px", display: "flex", alignItems: "center"}}>
                            <Typography style={{padding: "0 5px 0 25px"}}>
                                {t("findStretchAtLeast")}
                            </Typography>
                            {formJson.searchInfo.qdb_seq_type === "protein" && 
                            <>
                                <Tooltip arrow title={formJson.layout.errorIdList.includes("fragmentStretchPro") ? 'Please specify a valid number of required residues to match in your search. The number must be between 5 and 1000, and only 2 decimal places are allowed.': ""} placement="bottom">
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentStretchPro"
                                    variant="outlined"
                                    className={styles.smallTextBox}
                                    value={formJson.searchInfo.strat_fragment_window_length_pro}
                                    onChange={(e)=>{
                                        let test = e.currentTarget.value;
                                        if(test < 5 || test > 1000) {
                                            if(!formJson.layout.errorIdList.includes("fragmentStretchPro")) {
                                                formJson.layout.errorIdList.push("fragmentStretchPro");
                                            }
                                        } else {
                                            if(formJson.layout.errorIdList.includes("fragmentStretchPro")) {
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "fragmentStretchPro");
                                            }
                                        }
                                        formJson.searchInfo.strat_fragment_window_length_pro = test;
                                        setFormJson({...formJson});
                                    }}
                                    error={formJson.layout.errorIdList.includes("fragmentStretchPro")}
                                />
                                </Tooltip>
                                <Typography style={{padding: "0 5px"}}>
                                    {t("aminoAcidWith")}
                                </Typography>
                                <Tooltip arrow title={formJson.layout.errorIdList.includes("fragmentAminoAcidPro") ? 'Please specify a valid required % identity for your search. The number must be between 81 and 100, and only 2 decimal places are allowed.': ""} placement="bottom">
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentAminoAcidPro"
                                    variant="outlined"
                                    className={styles.smallTextBox}
                                    value={formJson.searchInfo.strat_fragment_perc_id_pro}
                                    onChange={handleDecimalInput((e)=>{
                                        let test = e.currentTarget.value;
                                        formJson.searchInfo.strat_fragment_perc_id_pro = test;
                                        if(test < 81 || test > 100) {
                                            if(!formJson.layout.errorIdList.includes("fragmentAminoAcidPro")) {
                                                formJson.layout.errorIdList.push("fragmentAminoAcidPro");
                                            }
                                        }else{
                                            if(formJson.layout.errorIdList.includes("fragmentAminoAcidPro")) {
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "fragmentAminoAcidPro");
                                            }
                                        }
                                        setFormJson({...formJson})
                                    })}
                                    error={formJson.layout.errorIdList.includes("fragmentAminoAcidPro")}
                                />
                                </Tooltip>
                                <Typography style={{padding: "0 5px"}}>
                                    % {t("identityOrMore")}
                                </Typography>
                            </>
                            }
                            {formJson.searchInfo.qdb_seq_type === "nucleotide" && 
                            <>
                                <Tooltip arrow title={formJson.layout.errorIdList.includes("fragmentStretchNuc") ? 'Please specify a valid number of required residues to match in your search. The number must be between 10 and 1000, and only 2 decimal places are allowed.': ""} placement="bottom">
                                <TextInput
                                    fullWidth={false}
                                    id="fragmentStretchNuc"
                                    variant="outlined"
                                    className={styles.smallTextBox}
                                    value={formJson.searchInfo.strat_fragment_window_length_nuc}
                                    onChange={(e)=>{
                                        let test = e.currentTarget.value;
                                        if(test < 10 || test > 1000) {
                                            if(!formJson.layout.errorIdList.includes("fragmentStretchNuc")) {
                                                formJson.layout.errorIdList.push("fragmentStretchNuc");
                                            }
                                        }else{
                                            if(formJson.layout.errorIdList.includes("fragmentStretchNuc")) {
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "fragmentStretchNuc");
                                            }
                                        }
                                        formJson.searchInfo.strat_fragment_window_length_nuc = test;
                                        setFormJson({...formJson});
                                    }}
                                    error={formJson.layout.errorIdList.includes("fragmentStretchNuc")}
                                />
                                </Tooltip>
                                <Typography style={{padding: "0 5px"}}>
                                    {t("nucleotidesWith")}
                                </Typography>
                                <Tooltip arrow title={formJson.layout.errorIdList.includes("fragmentAminoAcidNuc") ? 'Please specify a valid number of required amino acids to match in your search. The number must be between 91 and 100, and only 2 decimal places are allowed.': ""} placement="bottom">
                                    <TextInput
                                        fullWidth={false}
                                        id="fragmentAminoAcidNuc"
                                        variant="outlined"
                                        className={styles.smallTextBox}
                                        value={formJson.searchInfo.strat_fragment_perc_id_nuc}
                                        onChange={handleDecimalInput((e)=>{
                                            let test = e.currentTarget.value;
                                            formJson.searchInfo.strat_fragment_perc_id_nuc = test;
                                            if(test < 91 || test > 100) {
                                                if(!formJson.layout.errorIdList.includes("fragmentAminoAcidNuc")) {
                                                    formJson.layout.errorIdList.push("fragmentAminoAcidNuc");
                                                }
                                            }else{
                                                if(formJson.layout.errorIdList.includes("fragmentAminoAcidNuc")) {
                                                    formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "fragmentAminoAcidNuc");
                                                }
                                            }
                                            setFormJson({...formJson})
                                        })}
                                        error={formJson.layout.errorIdList.includes("fragmentAminoAcidNuc")}
                                    />
                                </Tooltip>
                                <Typography style={{padding: "0 5px"}}>
                                    % {t("identityOrMore")}
                                </Typography>
                                </>
                            }
                        </div>
                    }
                    {(formJson.searchInfo.strat_name === "kerr" || formJson.searchInfo.strat_name === "hash") &&
                    <div className={styles.alignMidRow} style={{marginTop: "-15px"}}>
                        <Typography style={{ marginLeft: '20px', paddingRight: "10px" }}>
                            {t("findAtleast")}
                        </Typography>
                        <Tooltip arrow title={formJson.layout.errorIdList.includes("genePastPercentage") ? 'Please specify a valid required % identity for your search. The number must be between 65 and 100, and only 2 decimal places are allowed. A useful default value is 80.' : ''} placement="bottom">  
                        <TextInput
                            fullWidth={false}
                            id="genePastPercentage"
                            variant="outlined"
                            className={styles.smallTextBox}
                            value={formJson.searchInfo.strat_genepast_perc_id}
                            onChange={handleDecimalInput((e)=>{
                                let test = e.currentTarget.value;
                                formJson.searchInfo.strat_genepast_perc_id = test;
                                if(test < 65 || test > 100) {
                                    if(!formJson.layout.errorIdList.includes("genePastPercentage")) {
                                        formJson.layout.errorIdList.push("genePastPercentage");
                                    }
                                }else{
                                    if(formJson.layout.errorIdList.includes("genePastPercentage")) {
                                        formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "genePastPercentage");
                                    }
                                }
                                setFormJson({...formJson})
                            })}
                            error={formJson.searchInfo.strat_genepast_perc_id < 65 || formJson.searchInfo.strat_genepast_perc_id > 100}
                        />
                        </Tooltip>
                        <Typography style={{ padding: "0 5px" }}>
                            % {t("identityOver")}
                        </Typography>
                        <div style={{marginTop: "10px", paddingLeft: "5px"}}>
                        <SelectBox
                            margin="normal"
                            variant="outlined"
                            id="genepastPercentageOver"
                            value={formJson.searchInfo.strat_genepast_perc_id_over}
                            items={genePastItems}
                            onChange={(e)=>{
                                let test = e.target.value;
                                formJson.searchInfo.strat_genepast_perc_id_over = test;
                                setFormJson({...formJson})
                            }}
                            className={"bodyText"}
                            style={{backgroundColor: '#292929'}}
                        />
                        </div>
                        {shouldShowMismatch() && (
                            <Typography style={{ marginLeft: '10px', fontStyle: 'italic', fontSize: '0.85rem', paddingTop: '10px' }}>
                                (up to {getMaxMismatches()} mismatches allowed)
                            </Typography>
                        )}
                    </div>
                    }
                    {formJson.searchInfo.strat_name === 'blast' && 
                    <div style={{ display: "flex", flexDirection: "column", padding: "0 25px", paddingBottom: "10px"}}>
                        <div className={styles.alignMidRow}>
                        <Typography style={{paddingRight: "12px", marginTop: "-9px"}}>
                            {t("scoringMatrix")}
                        </Typography>
                        {formJson.searchInfo.qdb_seq_type === 'nucleotide' && 
                        <SelectBox
                            margin="normal"
                            variant="outlined"
                            name="scoringMatrix"
                            id="scoringMatrixNuc"
                            value={formJson.searchInfo.strat_blast_scoring_matrix_nuc}
                            items={nucleotideMatrixItems}
                            className={"float-left"}
                            onChange={e =>{
                                let test = e.target.value;
                                formJson.searchInfo.strat_blast_scoring_matrix_nuc = test;
                                setFormJson({...formJson});
                            }}
                        />
                        }
                        {formJson.searchInfo.qdb_seq_type === 'protein' && 
                        <SelectBox
                            margin="normal"
                            variant="outlined"
                            name="scoringMatrix"
                            id="wordSizeProt"
                            value={formJson.searchInfo.strat_blast_scoring_matrix_pro}
                            items={proteinMatrixItems}
                            className={"float-left"}
                            onChange={(e) =>{
                                let test = e.target.value;
                                formJson.searchInfo.strat_blast_scoring_matrix_pro = test;
                                setFormJson({...formJson});
                            }}
                        />
                        }
                        <Typography style={{padding: "0 12px 0 10px", marginTop: "-9px"}}>
                          {t("wordSize")}
                        </Typography>
                        {formJson.searchInfo.qdb_seq_type === 'nucleotide' && 
                            <SelectBox
                                margin="normal"
                                variant="outlined"
                                id="wordSize"
                                className={styles.smallTextBox}
                                value={formJson.searchInfo.strat_blast_word_size_nuc}
                                items={nucleotidewordSizeItems}
                                onChange={(e) => {
                                    let test = e.target.value;
                                    formJson.searchInfo.strat_blast_word_size_nuc = test;
                                    setFormJson({...formJson})
                                }}
                            />
                        }
                        {formJson.searchInfo.qdb_seq_type === 'protein' && 
                                <SelectBox
                                    margin="normal"
                                    variant="outlined"
                                    id="wordSize"
                                    value={formJson.searchInfo.strat_blast_word_size_pro}
                                    items={proteinwordSizeItems}
                                    className={styles.smallTextBox}
                                    onChange={(e) => {
                                        let test = e.target.value;
                                        formJson.searchInfo.strat_blast_word_size_pro = test;
                                        setFormJson({...formJson})
                                    }}
                                />
                        }
                        </div>
                        <div className={styles.alignMidRow}>
                            <Typography style={{paddingRight: "12px"}}>
                                {t("expectCutOff")}
                            </Typography>
                            <Tooltip arrow title={formJson.layout.errorIdList.includes("strat_blast_eval_cutoff") ? 'Input a float value between 0 and 1000,000': ''} placement="bottom">
                            <TextInput
                                fullWidth={false}
                                id="strat_blast_eval_cutoff"
                                variant="outlined"
                                className={styles.smallTextBox}
                                value={formJson.searchInfo.strat_blast_eval_cutoff}
                                onChange={(e) => {
                                        let test = e.currentTarget.value;
                                        formJson.searchInfo.strat_blast_eval_cutoff = test;
                                        if(test < 0 || test > 1000000) {
                                            if(!formJson.layout.errorIdList.includes("strat_blast_eval_cutoff")) {
                                                formJson.layout.errorIdList.push("strat_blast_eval_cutoff");
                                            }
                                        }else{
                                            if(formJson.layout.errorIdList.includes("strat_blast_eval_cutoff")) {
                                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "strat_blast_eval_cutoff");
                                            }
                                        }
                                        setFormJson({...formJson})
                                    }}
                                error={formJson.layout.errorIdList.includes("strat_blast_eval_cutoff")}
                            />
                            </Tooltip>
                            <span style={{paddingLeft: "20px", display: "flex", lineBreak: "none", ali: "center"}}>
                            <CheckBox
                                color="primary"
                                name="processHsps"
                                id="processHsps"
                                onChange={(e) => {
                                        formJson.searchInfo.strat_blast_hsp = !formJson.searchInfo.strat_blast_hsp;
                                        setFormJson({...formJson})
                                    }}
                                checked={formJson.searchInfo.strat_blast_hsp == true}
                            />
                            <Typography style={{marginTop: "4px", paddingLeft: "3px"}}>
                                {t("processHsps")}
                            </Typography>
                            </span>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>

            {/* compare both removed for CM */}
            {false && 
            <div className={styles.alignMidRow} style={{marginTop: "10px"}}>
                <CheckBox
                    color="primary"
                    className={styles.moveDown}
                    name="compareboth"
                    id="compareboth"
                    disabled={formJson.searchInfo.searchAlgorithmValue && formJson.searchInfo.searchAlgorithmValue === 'motif' ? true : false}
                    onChange={(e)=>{}}
                    checked={false}
                    // onChange={() => calTextCredits("isCompare")}
                />
                <label className={"bodyText ml-0"} style={{marginTop: "7px"}} htmlFor="compareboth">{t("compareBothNucPro")}</label>
            </div>
            }
            {(formJson.searchInfo.strat_name === "kerr" || formJson.searchInfo.strat_name === "hash") && formJson.searchInfo.qdb_seq_type !== "protein" &&
            <div className={styles.alignMidRow} style={{margin: "10px 0 -10px -5px"}}>
                <CheckBox
                    // defaultChecked
                    color="primary"
                    className={"float-left"}
                    name="matchTu"
                    id="matchTu"
                    onChange={(e)=> {
                        let matchTu = e.target.checked;
                        formJson.searchInfo.match_tu = matchTu ? "1" : "0";
                        if(!matchTu){
                            setPrevFrameSel(formJson.searchInfo.frame_sel);
                            formJson.searchInfo.frame_sel = "for";
                        }else{
                            formJson.searchInfo.frame_sel = prevFrameSel;
                        }
                        setFormJson({...formJson});
                    }}
                    checked={formJson.searchInfo.match_tu === "1"}
                    disabled={formJson.layout.isRedo === true }
                />
                <label className={"bodyText ml-0"} style={{marginTop: "7px"}} htmlFor="matchTu">{t("matchTu")}</label>
            </div>
            }
            {formJson.searchInfo.strat_name !== "blast" && formJson.searchInfo.qdb_seq_type !== "protein" &&
            <div className={styles.alignMidRow}>
                <span className={"bodyText"}>Alignment Frame Selection: </span>
                <RadioGroup row aria-label="These are" name="customized-radios" value={false} 
                onChange={(e)=>{
                    let test = e.currentTarget.value;
                    formJson.searchInfo.frame_sel = test;
                    setFormJson({...formJson})
                }} 
                style={{marginTop: "10px", paddingLeft: "10px"}}>
                    <FormControlLabel value="both" control={<RadioButton checked={formJson.searchInfo.frame_sel === "both"} disabled={(formJson.layout.isRedo === true || formJson.searchInfo.match_tu !== "1") && (formJson.searchInfo.strat_name === "kerr" || formJson.searchInfo.strat_name === "hash")} />} label="Both " className="bodyText" />                                    
                    <FormControlLabel value="for" control={<RadioButton checked={formJson.searchInfo.frame_sel === "for"} disabled={(formJson.layout.isRedo === true || formJson.searchInfo.match_tu !== "1") && (formJson.searchInfo.strat_name === "kerr" || formJson.searchInfo.strat_name === "hash")} />} label="Forward " />
                    <FormControlLabel value="rev" control={<RadioButton checked={formJson.searchInfo.frame_sel === "rev"} disabled={(formJson.layout.isRedo === true || formJson.searchInfo.match_tu !== "1") && (formJson.searchInfo.strat_name === "kerr" || formJson.searchInfo.strat_name === "hash")} />} label="Reverse " />
                </RadioGroup>
            </div>
            }

            <div className={styles.alignMidRow}>
                <Typography style={{paddingRight: "10px"}}>
                    {t("Report")}
                </Typography>
                <Tooltip arrow title={formJson.layout.errorIdList.includes("alignments") ? 'Please input a valid number from 1 to 300000' : ''} placement="bottom">
                <TextInput
                    fullWidth={false}
                    id="alignments"
                    variant="outlined"
                    value={formJson.searchInfo.best_hit_keep_max}
                    onChange={(e)=>{
                        let test  = e.currentTarget.value;
                        if(test<1 || test> 300000) {
                            if(!formJson.layout.errorIdList.includes("alignments")) {
                                formJson.layout.errorIdList.push("alignments");
                            }
                        } else {
                            if(formJson.layout.errorIdList.includes("alignments")) {
                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "alignments");
                            }
                        }
                        formJson.searchInfo.best_hit_keep_max = test;
                        setFormJson({...formJson})
                    }}
                    error={formJson.searchInfo.best_hit_keep_max < 1 || formJson.searchInfo.best_hit_keep_max > 300000}
                />
                </Tooltip>
                <Typography style={{paddingLeft: "10px"}}>
                {t("bestAlignmentsPerQuerySeq")}
                </Typography>
            </div>
            
        </div>
    )
}

export default SearchAlgosSettings